import React from 'react';
import { GraduationCap } from 'lucide-react';

const About = () => {
  return (
    <section id="tentang" className="py-24 px-6 bg-white">
      <div className="max-w-4xl mx-auto">
        <div className="flex items-center gap-3 mb-8">
          <div className="p-3 bg-sage-100 rounded-xl">
            <GraduationCap className="w-6 h-6 text-sage-700" />
          </div>
          <h2 className="font-serif text-4xl font-bold text-gray-900">Tentang Wisuda.ai</h2>
        </div>
        
        <div className="space-y-6 text-lg text-gray-700 leading-relaxed">
          <p className="border-l-4 border-sage-300 pl-6 py-2">
            Wisuda adalah momen akademik yang penting dan bermakna. Namun dalam pelaksanaannya, 
            kampus dan panitia sering menghadapi tantangan komunikasi, koordinasi, dan dokumentasi.
          </p>
          
          <p>
            Wisuda.ai hadir sebagai platform pendukung acara wisuda yang membantu kampus mengelola 
            arus informasi secara tertib, konsisten, dan mudah diakses oleh seluruh peserta melalui 
            satu kanal resmi: <span className="font-semibold text-sage-700">WhatsApp</span>.
          </p>
        </div>
      </div>
    </section>
  );
};

export default About;
